import type { ButtonHTMLAttributes } from 'react'
import { cn } from '../lib/cn'

export type ChipTone = 'prompt' | 'skill' | 'neutral'

export interface ChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ChipTone
}

export function Chip({ tone = 'neutral', className, ...props }: ChipProps) {
  return (
    <button
      className={cn(
        'inline-flex items-center rounded-full border px-3 py-1.5 text-sm font-medium transition-colors',
        tone === 'prompt' && 'border-neutral-200 text-accent hover:bg-accent-50',
        tone === 'skill' && 'border-neutral-200 text-brand-600 hover:bg-brand-50',
        tone === 'neutral' && 'border-neutral-200 text-neutral-700 hover:bg-neutral-50',
        className,
      )}
      {...props}
    />
  )
}
